<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
    <blacklist-dialog ref="blacklistDialog"></blacklist-dialog>
  </div>
</template>

<script>

import UPDATE from "@/components/page/update.vue";
import tablePage from "@/components/page/table.vue";
import FORM from "@/components/page/form.vue";
import URL from "@/views/mis/util/url";
import { dataChange } from '@/utils/dataChange';
import BlacklistDialog from "./blacklist.vue";

const statusMap = { 1: true, 2: false };
const statusReverseMap = { "true": 1, "false": 2 };
let areaMd5ToNameMap = {};
let areaNameToMd5Map = {};

export default {
  components: {
    FORM,
    UPDATE,
    tablePage,
    BlacklistDialog
  },
  created () {
    this.statusOptionList = [
      {key: 1, value: window.$t("mis.bt.enable")},
      {key: 2, value: window.$t("mis.bt.disable")}
    ];
    this.getOptions();
  },
  mounted(){
    this.$set(this.formData.cols[1], "optionList", this.statusOptionList);
    this.$set(this.updateData.cols[3], "optionList", this.statusOptionList);
    this.$forceUpdate();
  },
  methods: {
    formClick (clickName, data) {
      // console.log("formClick: ", clickName, data);
      if (clickName === "init") {
        this.$refs.childTable.defaultQueryData(this.queryData);
      } else if (clickName === "query") {
        this.queryData = data;
        if (this.queryData.status) {
          this.queryData.status = statusMap[this.queryData.status];
        }
        this.$refs.childTable.defaultGetData(this.queryData);
      } else if (clickName === "add") {
        this.modalData = {};
        this.$refs.childUpdate.open(this.modalData);
      } else if (clickName === "reset") {
        this.queryData = {};
        this.$refs.childTable.defaultQueryData(this.queryData);
      } else if (clickName === "manageBlacklist") {
        this.$refs.blacklistDialog.open(); // 打開彈窗
      }
    },
    bthClick (clickName, row) {
      // console.log("bthClick: ", clickName, row);
      if (clickName === "update") {
        this.modalData = {};
        this.modalData.id = row.id;
        this.modalData.appName = row.appName;
        this.modalData.appFlavor = row.appFlavor;
        this.modalData.status = statusReverseMap[`${row.status}`];
        this.modalData.area = row.area;
        this.modalData.remark = row.remark;
        this.$refs.childUpdate.open(this.modalData);
      } else if (clickName === "delete") {
        if (!row.id) this.$message.error(window.$t("mis.appAbChannel.message.invalid"));
        this.delete(row.id)
      } else if (clickName === "export") {
        if (!row.id) this.$message.error(window.$t("mis.appAbChannel.message.invalid"));
        this.requestExcel(row.id, row.appName)
      }
    },
    submit (payload) {
      console.log("submit form: ", payload);
      let submitData = {};
      if (payload.id) {
        submitData.id = payload.id;
      }
      if (payload.remark) {
        submitData.remark = payload.remark;
      }
      submitData.appName = payload.appName;
      submitData.appFlavor = payload.appFlavor;
      submitData.status = statusMap[payload.status];
      if (payload.area && Array.from(payload.area).length > 0) {
        submitData.area = Array.from(payload.area).map(item => Array.from(item).map(el => areaMd5ToNameMap[el]).join("|")).join();
      }
      console.log("submit data: ", submitData);
      this.saveOrUpdate(submitData);
    },
    getOptions () {
      dataChange(URL.cnAreaDict.list, {}, (res) => {
        if(res.code === 0) {
          console.log(res);
          let options = Array.from(res.result).length > 0 ? Array.from(res.result) : [];
          this.areaDictOptionList = options.map(item => {
            if (item.children && item.children.length === 0) {
              const { children, ...rest } = item;
              return rest;
            }
            return item;
          });
          // Construct Area Map
          options.flatMap(item => {
            const { children, ...rest } = item;
            if (children && children.length > 0) {
              return [rest, ...children];
            } else {
              return [rest];
            }
          }).forEach(option => {
            areaMd5ToNameMap[option.value] = option.label;
            areaNameToMd5Map[option.label] = option.value;
          })
        }
      }, (err) => {this.errorHandle(err)}).then((res) => {
        this.$set(this.updateData.cols[4], "optionList", this.areaDictOptionList);
        this.$forceUpdate();
      })
    },
    saveOrUpdate (data) {
      let url = URL.appAbChannel.save;
      if (data.id) {
        url = URL.appAbChannel.update;
      }
      dataChange(url, data, (res) => {
        // console.log(res);
        if (res.code === 0) {
          if(res.result) {
            this.$message.success(window.$t("mis.appAbChannel.message.success"));
          } else {
            this.$message.error(window.$t("mis.appAbChannel.message.fail") +
              window.$t("mis.appAbChannel.message.duplicate"));
          }
          this.$refs.childUpdate.close();
          this.modalData = {};
        }
      }, (err) => {this.errorHandle(err)}, "POST", "json").then(() => {
        this.$refs.childUpdate.close();
        this.refreshTable();
      });
    },
    delete (id) {
      // console.log("delete: ", id);
      let url = URL.appAbChannel.delete + id;
      dataChange(url, {}, (res) => {
        // console.log(res);
        if (res.code === 0) {
          this.successHandle(res);
        }
      }, (err) => {this.errorHandle(err)}).then(() => {
        this.refreshTable();
      });
    },
    requestExcel(id, appName) {
      let url = URL.appAbChannel.export + id;
      dataChange(url, {}, (res) => {
        console.log(res);
        const data = res.data == null ? res : res.data;
        const blob =new Blob([data], { type: 'application/vnd.ms-excel' });

        const href = window.URL.createObjectURL(blob);

        const anchorElement = document.createElement('a');

        anchorElement.href = href;

        // 1) Get the value of content-disposition header
        const contentDisposition = res.headers == null ? "" : res.headers['Content-Disposition'];
        // console.log('contentDisposition: ', contentDisposition);

        // 2) set the fileName variable to the default value
        let fileName = appName + window.$t("mis.appAbChannel.common.filename") + Date.now() +".xlsx";

        // 3) if the header is set, extract the filename
        if (contentDisposition) {
          const fileNameMatch =
            contentDisposition.match(/filename="(.+)"/);
          console.log('fileNameMatch', fileNameMatch);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }

        anchorElement.download = fileName;

        document.body.appendChild(anchorElement);
        anchorElement.click();

        document.body.removeChild(anchorElement);
        window.URL.revokeObjectURL(href);
      }, (err) => {this.errorHandle(err)}, "GET", null, "blob");
    },
    successHandle (success) {
      if(success.result) {
        this.$message.success(window.$t("mis.appAbChannel.message.success"));
      } else {
        this.$message.error(window.$t("mis.appAbChannel.message.fail"));
      }
    },
    errorHandle(error) {
      const errorMessage =
        (error.response && error.response.data && error.response.data.message) ||
        window.$t("mis.appAbChannel.message.unknown");
      this.$message.error(
        window.$t("mis.appAbChannel.message.fail") + ": " + errorMessage
      );
    },
    refreshTable() {
      this.$refs.childTable.defaultGetData(this.queryData);
      this.$forceUpdate();
    }

  },
  data() {
    return {
      // OptionList data
      statusOptionList: [],
      areaDictOptionList: [],
      // Data
      queryData:{},
      modalData:{},
      // Query form
      formData: {
        hasLable : true,
        initClickName: "init",
        cols:[
          { title: window.$t("mis.appAbChannel.form.appName.label"), field: "appName",
            placeholder: window.$t("mis.appAbChannel.form.appName.placeholder") },
          { title: window.$t("mis.appAbChannel.form.status.label"), field: "status", type: 2, optionList: [],
            placeholder: window.$t("mis.appAbChannel.form.status.placeholder") },
          { title: window.$t("mis.appAbChannel.form.area.label"), field: "area",
            placeholder: window.$t("mis.appAbChannel.form.area.placeholder") },
          { buttonLabel: window.$t("mis.bt.query"), click: "query" },
          { buttonLabel: window.$t("mis.bt.add"), click: "add" },
          { buttonLabel:  window.$t("mis.appAbChannel.form.button.blacklist"), click: "manageBlacklist", type: "warning" },
          { buttonLabel: window.$t("mis.bt.reset"), click: "reset" },
        ]
      },
      // Table
      pageData: {
        fieldTotal: "recordsFiltered",
        fieldData: "data",
        queryUrl: URL.appAbChannel.query,
        method: "post-json",
        sequence: true,
        cols: [
          { title: window.$t("mis.appAbChannel.common.id"), field: "id", hidden: true },
          { title: window.$t("mis.appAbChannel.table.appName"), field: "appName" },
          { title: window.$t("mis.appAbChannel.table.appFlavor"), field: "appFlavor" },
          { title: window.$t("mis.appAbChannel.table.status"), field: "status", render: (data, full) => {
              return data ? window.$t("mis.bt.enable") : window.$t("mis.bt.disable");
            } },
          { title: window.$t("mis.appAbChannel.table.area"), field: "area", render: (data, full) => {
              if (data && data.length > 0) {
                return Array.from(data).map(item => Array.from(item).map(el => areaMd5ToNameMap[el]).join("|")).join();
              }else {
                return window.$t("mis.appAbChannel.common.emptyArea");
              }
            } },
          { title: window.$t("mis.appAbChannel.table.updatedAt"), field: "updatedAt", render: (data, full) => {
              return data ? data : "";
            }  },
          { title: window.$t("mis.appAbChannel.table.updatedBy"), field: "updatedBy", render: (data, full) => {
              return data ? data : "";
            } },
          { title: window.$t("mis.bt.operation"), btnClick: [
              { name: window.$t("mis.appAbChannel.table.operation.export"), size: "mini", click: "export", type: "primary", icon: "el-icon-edit" },
              { name: window.$t("mis.bt.edit"), size: "mini", click: "update", type: "primary", icon: "el-icon-edit" },
              { name: window.$t("mis.bt.delete"), size: "mini", click: "delete", type: "danger", icon: "el-icon-delete" }
            ]
          }
        ]
      },
      // Add/Update modal
      updateData: {
        cols: [
          { title: window.$t("mis.appAbChannel.common.id"), field: "id", hidden: true},
          { title: window.$t("mis.appAbChannel.modal.appName.label"), field: "appName", require: true,
            placeholder: window.$t("mis.appAbChannel.modal.appName.placeholder") },
          { title: window.$t("mis.appAbChannel.modal.appFlavor.label"), field: "appFlavor", require: true,
            placeholder: window.$t("mis.appAbChannel.modal.appFlavor.placeholder") },
          { title: window.$t("mis.appAbChannel.modal.status.label"), field: "status", require: true, type: 2, optionList: [],
            placeholder: window.$t("mis.appAbChannel.modal.area.placeholder") },
          { title: window.$t("mis.appAbChannel.modal.area.label"), field: "area", require: true, type: 15, multiple: true, collapse: true, optionList: [],
            placeholder: window.$t("mis.appAbChannel.modal.status.placeholder") },
          { title: window.$t("mis.appAbChannel.modal.remark.label"), field: "code",
            placeholder: window.$t("mis.appAbChannel.modal.remark.placeholder") },
        ]
      }
    }
  }
}

</script>

<style scoped>

</style>
